(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-17"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('gearhaven-switches-scroll')) {

    class GearHavenSwitchesScroll extends HTMLElement {

      constructor() {
        super();

        this.sticky = null;
        this.viewport = null;
        this.track = null;
        this.progressFill = null;

        this.maxTranslate = 0;
        this.scrollRange = 0;
        this.stickyTop = 0;

        this.raf = null;

        this.resizeObserver = null;

        this.desktopMedia = window.matchMedia(
          '(min-width: 750px)'
        );

        this.reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.handleScroll =
          this.handleScroll.bind(this);

        this.handleResize =
          this.handleResize.bind(this);

        this.setup =
          this.setup.bind(this);

        this.update =
          this.update.bind(this);
      }

      connectedCallback() {

        this.sticky =
          this.querySelector(
            '.ghs-sticky'
          );

        this.viewport =
          this.querySelector(
            '.ghs-viewport'
          );

        this.track =
          this.querySelector(
            '.ghs-track'
          );

        this.progressFill =
          this.querySelector(
            '.ghs-progress-fill'
          );

        if (
          !this.sticky ||
          !this.viewport ||
          !this.track
        ) {
          return;
        }

        window.addEventListener(
          'scroll',
          this.handleScroll,
          {
            passive: true
          }
        );

        window.addEventListener(
          'resize',
          this.handleResize,
          {
            passive: true
          }
        );

        this.desktopMedia.addEventListener(
          'change',
          this.handleResize
        );

        this.reducedMotion.addEventListener(
          'change',
          this.handleResize
        );

        if (
          'ResizeObserver'
          in window
        ) {

          this.resizeObserver =
            new ResizeObserver(
              () => {
                this.scheduleSetup();
              }
            );

          this.resizeObserver.observe(
            this.viewport
          );

          this.resizeObserver.observe(
            this.track
          );

        }

        this.querySelectorAll(
          'img'
        ).forEach(
          (image) => {

            if (
              image.complete
            ) {
              return;
            }

            image.addEventListener(
              'load',
              () => {
                this.scheduleSetup();
              },
              {
                once: true
              }
            );

          }
        );

        requestAnimationFrame(
          () => {
            this.setup();
          }
        );
      }

      disconnectedCallback() {

        window.removeEventListener(
          'scroll',
          this.handleScroll
        );

        window.removeEventListener(
          'resize',
          this.handleResize
        );

        this.desktopMedia.removeEventListener(
          'change',
          this.handleResize
        );

        this.reducedMotion.removeEventListener(
          'change',
          this.handleResize
        );

        if (
          this.resizeObserver
        ) {
          this.resizeObserver.disconnect();
        }

        if (
          this.raf
        ) {
          cancelAnimationFrame(
            this.raf
          );
        }

      }

      scheduleSetup() {

        if (
          this.setupFrame
        ) {
          cancelAnimationFrame(
            this.setupFrame
          );
        }

        this.setupFrame =
          requestAnimationFrame(
            () => {
              this.setup();
            }
          );

      }

      handleResize() {

        this.scheduleSetup();

      }

      setup() {

        if (
          !this.sticky ||
          !this.viewport ||
          !this.track
        ) {
          return;
        }

        if (
          !this.desktopMedia.matches ||
          this.reducedMotion.matches
        ) {

          this.style.height =
            'auto';

          this.track.style.transform =
            'translate3d(0, 0, 0)';

          if (
            this.progressFill
          ) {
            this.progressFill.style.transform =
              'scaleX(0)';
          }

          return;
        }

        const stickyStyle =
          window.getComputedStyle(
            this.sticky
          );

        this.stickyTop =
          parseFloat(
            stickyStyle.top
          ) || 0;

        const stickyHeight =
          this.sticky.offsetHeight;

        const viewportWidth =
          this.viewport.clientWidth;

        const trackWidth =
          this.track.scrollWidth;

        this.maxTranslate =
          Math.max(
            0,
            trackWidth -
            viewportWidth
          );

        const rawFactor =
          Number(
            this.dataset.scrollFactor
          ) || 120;

        const scrollFactor =
          rawFactor / 100;

        this.scrollRange =
          Math.max(
            1,
            this.maxTranslate *
            scrollFactor
          );

        if (
          this.maxTranslate <= 1
        ) {

          this.style.height =
            `${stickyHeight}px`;

          this.track.style.transform =
            'translate3d(0, 0, 0)';

          if (
            this.progressFill
          ) {
            this.progressFill.style.transform =
              'scaleX(1)';
          }

          return;
        }

        this.style.height =
          `${
            stickyHeight +
            this.scrollRange
          }px`;

        this.update();

      }

      handleScroll() {

        if (
          this.raf
        ) {
          return;
        }

        this.raf =
          requestAnimationFrame(
            () => {

              this.update();

              this.raf =
                null;

            }
          );

      }

      update() {

        if (
          !this.desktopMedia.matches ||
          this.reducedMotion.matches ||
          this.maxTranslate <= 0
        ) {
          return;
        }

        const rect =
          this.getBoundingClientRect();

        const travelled =
          this.stickyTop -
          rect.top;

        const progress =
          Math.min(
            1,
            Math.max(
              0,
              travelled /
              this.scrollRange
            )
          );

        const translate =
          this.maxTranslate *
          progress;

        this.track.style.transform =
          `translate3d(${-translate}px, 0, 0)`;

        if (
          this.progressFill
        ) {

          this.progressFill.style.transform =
            `scaleX(${progress})`;

        }

      }

    }

    customElements.define(
      'gearhaven-switches-scroll',
      GearHavenSwitchesScroll
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  function initGearHavenMegaTickers() {

    const template =
      document.getElementById(
        'GearHavenMegaTickerTemplate'
      );

    if (!template) {
      return;
    }

    const megaMenus =
      document.querySelectorAll(
        '.mega-menu__content'
      );

    megaMenus.forEach(
      (megaMenu) => {

        if (
          megaMenu.querySelector(
            '.gh-rule-ticker'
          )
        ) {
          return;
        }

        const ticker =
          template.content.cloneNode(true);

        megaMenu.appendChild(
          ticker
        );

      }
    );

  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initGearHavenMegaTickers,
      {
        once: true
      }
    );

  } else {

    initGearHavenMegaTickers();

  }

  document.addEventListener(
    'shopify:section:load',
    initGearHavenMegaTickers
  );


  class StickyHeader extends HTMLElement {

    constructor() {
      super();

      this.setHeaderHeight =
        this.setHeaderHeight.bind(this);
    }

    connectedCallback() {

      this.header =
        document.querySelector(
          '.section-header'
        );

      this.mobileMediaQuery =
        window.matchMedia(
          '(max-width: 990px)'
        );

      this.headerIsAlwaysSticky =
        this.getAttribute(
          'data-sticky-type'
        ) === 'always' ||
        this.getAttribute(
          'data-sticky-type'
        ) === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener(
        'change',
        this.setHeaderHeight
      );

      if (
        this.headerIsAlwaysSticky
      ) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      }

      this.currentScrollTop =
        0;

      this.preventReveal =
        false;

      this.predictiveSearches =
        this.querySelectorAll(
          'predictive-search'
        );

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => (
          this.preventReveal = true
        );

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();

    }

    setHeaderHeight() {

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }

    disconnectedCallback() {

      this.mobileMediaQuery.removeEventListener(
        'change',
        this.setHeaderHeight
      );

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }

    createObserver() {

      const observer =
        new IntersectionObserver(
          (
            entries,
            currentObserver
          ) => {

            this.headerBounds =
              entries[0].intersectionRect;

            currentObserver.disconnect();

          }
        );

      observer.observe(
        this.header
      );

    }

    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        [...this.predictiveSearches].some(
          (
            predictiveSearch
          ) =>
            predictiveSearch.isOpen
        )
      ) {
        return;
      }

      if (
        scrollTop >
          this.currentScrollTop &&
        scrollTop >
          this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          this.preventHide
        ) {
          return;
        }

        requestAnimationFrame(
          this.hide.bind(this)
        );

      }

      else if (
        scrollTop <
          this.currentScrollTop &&
        scrollTop >
          this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.preventReveal
        ) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        }

        else {

          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(
              () => {
                this.preventReveal =
                  false;
              },
              66
            );

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      }

      else if (
        scrollTop <=
          this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );

      }

      this.currentScrollTop =
        scrollTop;

    }

    hide() {

      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }

    reveal() {

      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }

    reset() {

      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }

    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (
          disclosure
        ) =>
          disclosure.close()
      );

    }

    closeSearchModal() {

      this.searchModals =
        this.searchModals ||
        this.header.querySelectorAll(
          'details-modal'
        );

      this.searchModals.forEach(
        (
          searchModal
        ) =>
          searchModal.close(false)
      );

    }

  }

  document.addEventListener(
    'open',
    (
      event
    ) => {

      if (
        !(
          event.target
          instanceof HTMLElement
        ) ||
        !event.target.matches(
          'shopify-account'
        )
      ) {
        return;
      }

      const bottom =
        Math.max(
          0,
          Math.round(
            event.target
              .getBoundingClientRect()
              .bottom
          )
        );

      event.target.style.setProperty(
        '--account-dialog-top',
        `${bottom}px`
      );

    },
    true
  );

  if (
    !customElements.get(
      'sticky-header'
    )
  ) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );

  }


  } catch(e) { console.error(e); }
})();
})();
